import { PREFIX_MOB_PHONE } from 'const';

export const formatPhone = (
  phoneNumber: string,
  prefix: string | undefined = `${PREFIX_MOB_PHONE}`,
  hooks: boolean | undefined = true
) => {
  if (phoneNumber) {
    if (phoneNumber.length >= 9) {
      const phone = phoneNumber.replace(/\D/g, '');

      if (!phone) {
        return '';
      }

      if (hooks) {
        return `${prefix} ${phone.slice(0, 3)} ${phone.slice(3, 6)} ${phone.slice(6, 11)}`;
      } else {
        return `${prefix} ${phone.slice(0, 3)} ${phone.slice(3, 6)} ${phone.slice(6, 11)}`;
      }
    } else {
      return phoneNumber;
    }
  } else {
    return null;
  }
};

export const secureFormatPhone = (
  phoneNumber: string,
  prefix: string | undefined = `${PREFIX_MOB_PHONE}`,
  hooks: boolean | undefined = true
) => {
  if (phoneNumber) {
    if (phoneNumber.length >= 9) {
      const phone = phoneNumber.replace(/\D/g, '');

      if (!phone) {
        return '';
      }

      if (hooks) {
        return `${prefix}${phone[0]}XX XXXXXX`;
      } else {
        return `${prefix}${phone[0]}XX XXXXXX`;
      }
    } else {
      return phoneNumber;
    }
  } else {
    return null;
  }
};
